import HeroHeader from 'modules/common/HeroHeader';
import PropTypes from 'prop-types';
import React, {Component} from 'react';
import {injectIntl} from 'react-intl';
import {connect} from 'react-redux';
import {compose, withProps} from 'recompose';
import updateCodeChallengeProgress from '../actions/progress';
import {checkResult} from '../actions/submit';
import CodeChallengeTask from '../components/CodeChallengeTask';

class CodeChallenge extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentPosition: 0,
      showScore: false,
    };
  }

  componentDidMount() {
    const {dispatch} = this.props;
    setTimeout(() => dispatch({type: 'CODE_CHALLENGE_SIDEBAR_HIDE'}), 1000);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const {step} = this.props;
    if (step.id !== nextProps.step.id) {
      this.setState({currentPosition: 0});
    }
  }

  componentWillUnmount() {
    const {dispatch} = this.props;
    dispatch({type: 'CODE_CHALLENGE_SIDEBAR_SHOW'});
  }

  checkResult = ({callback, data}) => {
    const {relatedSteps, step, stepProgress, dispatch} = this.props;
    let modifiedCallback = callback;
    if (this.state.currentPosition === 0) {
      modifiedCallback = (args) => {
        callback(args);
        dispatch(
          updateCodeChallengeProgress({
            id: step.id,
            is_help_used: data.is_help_used,
            related_steps: relatedSteps,
          }),
        );
      };
    }
    const last =
      this.state.currentPosition >=
      step.codechallenge.codechallengetaskSet.edges.length - 1;
    if (last && stepProgress !== 'completed') {
      this.setState({showScore: true});
      modifiedCallback = (args) => {
        callback(args);
        dispatch(
          updateCodeChallengeProgress({
            id: step.id,
            is_help_used: data.is_help_used,
            completed: true,
            related_steps: relatedSteps,
          }),
        );
      };
    }
    dispatch(
      checkResult({
        callback: modifiedCallback,
        data,
      }),
    );
  };

  next = () => {
    this.setState((prevState) => ({
      currentPosition: prevState.currentPosition + 1,
    }));
  };

  tryAgain = () => {
    this.setState({currentPosition: 0});
  };

  render() {
    const {
      authenticated,
      codeChallengeHelperYoutubeId,
      nextStepProps,
      step,
      stepProgress,
      userId,
      dispatch,
      intl: {formatMessage},
      trackSlug,
      isDegree,
    } = this.props;
    const codechallengeTasks = step.codechallenge.codechallengetaskSet.edges;
    const last =
      codechallengeTasks &&
      this.state.currentPosition >= codechallengeTasks.length - 1;
    return (
      <div className="bg-white">
        <HeroHeader
          title={
            (!authenticated &&
              formatMessage({
                id: 'challenge',
              })) ||
            (this.state.currentPosition + 1 <= codechallengeTasks.length
              ? `${formatMessage({
                  id: 'challenge',
                })} : ${formatMessage({id: 'task'})} ${
                  this.state.currentPosition + 1
                } ${formatMessage({
                  id: 'of',
                })} ${codechallengeTasks.length}`
              : formatMessage({id: 'challenge_finished'}))
          }
          trackSlug={trackSlug}
          isDegree={isDegree}
        />
        {authenticated && (
          <div>
            <CodeChallengeTask
              description={step.codechallenge.description}
              color="#61ca92"
              codeChallengeHelperYoutubeId={codeChallengeHelperYoutubeId}
              last={last}
              next={this.next}
              nextStepProps={nextStepProps}
              sourceCodes={step.codechallenge.sourcecodeSet.edges}
              task={codechallengeTasks[this.state.currentPosition].node}
              currentPosition={this.state.currentPosition}
              challenges={codechallengeTasks}
              codeChallengeId={step.id}
              dispatch={dispatch}
              checkResult={this.checkResult}
              showScore={this.state.showScore}
              id={step.id}
              stepProgress={stepProgress}
              userId={userId}
            />
          </div>
        )}
      </div>
    );
  }
}
CodeChallenge.propTypes = {
  authenticated: PropTypes.bool.isRequired,
  codeChallengeHelperYoutubeId: PropTypes.string,
  nextStepProps: PropTypes.object.isRequired,
  relatedSteps: PropTypes.array.isRequired,
  step: PropTypes.shape({
    id: PropTypes.number.isRequired,
    codechallenge: PropTypes.shape({
      codechallengetaskSet: PropTypes.object.isRequired,
      description: PropTypes.string.isRequired,
      sourcecodeSet: PropTypes.object.isRequired,
    }).isRequired,
  }).isRequired,

  stepProgress: PropTypes.string.isRequired,
  userId: PropTypes.number,
  intl: PropTypes.object,
  dispatch: PropTypes.func,
  trackSlug: PropTypes.string.isRequired,
  isDegree: PropTypes.bool.isRequired,
};

const mapStateToProps = ({user: {profile, progress}}, ownProps) => ({
  stepProgress:
    (progress.step && progress.step[ownProps.codechallenge.id]) || 'pending',
  userId: profile.data.id,
});
const enhance = compose(
  withProps(({step}) => ({codechallenge: step})),
  connect(mapStateToProps),
  injectIntl,
);

export default enhance(CodeChallenge);
